import { Module, GetterTree, MutationTree, ActionTree } from 'vuex'
import { forOwn } from 'lodash'

import { vm } from '../../main'
import RootState from '../RootState'
import ReportState from '../ReportState'

import { mapData, REPORT_API_MAPPING } from '../../api/Mapping'
import Report from '../../models/Report'
import { MutationType as RootMutationType } from '../index'

import { ReportStateType } from '@/enums/ReportStateType'

import { Error } from '../../api/Error'
import { checkError } from '../Error'

const INITIAL_STATE: ReportState = {
  autoRestart: false,
  createdAt: null,
  description: null,
  dropoff: false,
  dropoffFinishedAt: null,
  finishedAt: null,
  fullDropoff: false,
  id: null,
  identifier: null,
  imagePath: null,
  ownerId: null,
  parts: null,
  process: null,
  proovCode: null,
  state: null,
  template: null,
  title: null,
  updatedAt: null,
  gallery: {
    partID: null,
    photoID: null,
    orientation: null
  }
}

const reportState: ReportState = INITIAL_STATE

const reportGetters: GetterTree<ReportState, RootState> = {
  canShowValues(state): boolean {
    return state.state !== ReportStateType.Waiting
  },
  canEditValues(state): boolean {
    return !state.proovCode || state.state === ReportStateType.Waiting
  },
  canShowDropoffValues(state): boolean {
    return state.proovCode && state.dropoff && state.state === ReportStateType.Finished
  },
  canEditDropoffValues(state): boolean {
    return state.state === ReportStateType.Return
  },
  isFinished(state): boolean {
    return state.state === ReportStateType.Finished
  },
  isWaiting(state): boolean {
    return state.state === ReportStateType.Waiting
  },
  isReturn(state): boolean {
    return state.state === ReportStateType.Return
  },
  proovCode(state): string {
    return state.proovCode
  },
  gallery(state) {
    return state.gallery
  },
  orientation(state) {
    return state.gallery.orientation
  },
  dropoff(state) {
    return state.dropoff
  }
}

enum MutationType {
  SetReport = 'setReport',
  UpdateGallery = 'updateGallery'
}

const reportMutations: MutationTree<ReportState> = {
  [MutationType.SetReport]: (state, payload) => {
    forOwn(payload, (value, key) => {
      state[key] = value
    })
  },
  [MutationType.UpdateGallery]: (state, payload) => {
    state.gallery = { ...payload }
  }
}

const reportActions: ActionTree<ReportState, RootState> = {
  async fetchReport({ commit, rootGetters }, payload) {
    try {
      const res = await vm.$api.reports.fetchReport(rootGetters.token, payload.code)
      const newReport = new Report(mapData(REPORT_API_MAPPING, res.data, false, true))
      // console.log('api', res.data, 'model = ', newReport)
      newReport.parseReport(res.data, payload.locale)
      commit(MutationType.SetReport, newReport)
      return newReport
    } catch (error) {
      checkError(commit, error)
      throw error
    }
  },
  async loadTemplate({ commit, rootGetters }, payload) {
    try {
      const res = await vm.$api.templates.fetchTemplate(rootGetters.token, payload)
      const newReport = new Report(mapData(REPORT_API_MAPPING, res.data, false, true))
      newReport.parseReport(res.data, payload.locale)
      commit(MutationType.SetReport, newReport)
      return newReport
    } catch (error) {
      checkError(commit, error)
      throw error
    }
  },
  updateGallery({ commit }, payload) {
    commit(MutationType.UpdateGallery, payload)
  }
}

export const report: Module<ReportState, RootState> = {
  namespaced: true,
  state: reportState,
  getters: reportGetters,
  mutations: reportMutations,
  actions: reportActions
}
